import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import { Link } from 'react-router-dom';


function MapaScreen() {
    return (
        <Fragment>
            <Head titulo="Mapa do Portal da Transparência" />
            <Header />
            <Container>
                <Fragment>
                    <h4>Mapa do Portal da Transparência</h4>
                    <nav>
                        <ul>
                            <li><Link to="/">Início</Link></li>
                            <li><Link to="/perguntas">Perguntas Frequentes</Link></li>
                            <li><Link to="/mapa">Mapa do Portal</Link></li>
                            <li>
                                <h4>Institucional</h4>
                                <ul>
                                    <li><Link to="/orgaos">Órgãos</Link></li>
                                    <li><Link to="/orgaos/carta">Carta</Link></li>
                                    <li><Link to="/orgaos/secretarias">Secretarias</Link></li>
                                    <li><Link to="/orgaos/locais/saude">Pontos de Atendimento de Saúde</Link></li>
                                    <li><Link to="/orgaos/locais/educacao">Unidades Escolares e de Educação</Link></li>
                                    <li><Link to="/orgaos/locais/social">Pontos de Atendimento de Assistência Social</Link></li>
                                    <li><Link to="/orgaos/locais/esporte">Quadras e Locais para práticas Esportivas</Link></li>
                                    <li><Link to="/orgaos/locais">Todos Órgãos Municipais</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Recursos Humanos</h4>
                                <ul>
                                    <li><Link to="/folha">Folha de Pagamento</Link></li>
                                    <li><Link to="/folha/concursos">Concursos</Link></li>
                                    <li><Link to="/folha/estagiarios">Estagiários</Link></li>
                                    <li><Link to="/folha/terceirizados">Terceirizados</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Diárias de Viagem</h4>
                                <ul>
                                    <li><Link to="/diarias">Diárias</Link></li>
                                    <li><Link to="/diarias/tabela">Tabela de Diárias</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Renúncias de Receita</h4>
                                <ul>
                                    <li><Link to="/renuncias">Tela de Renúncias Gerais</Link></li>
                                    <li><Link to="/projetocultural">Projetos Culturais</Link></li>
                                    <li><Link to="/renunciareceita">Renúncias de Receitas detalhadas</Link></li>
                                    <li><Link to="/contas/renuncias">Renúncias de Receita por ano</Link></li>
                                </ul>
                            </li>
                            <li><Link to="/concessaocedae">Concessão CEDAE</Link></li>
                            <li>
                                <h4>Contas</h4>
                                <ul>
                                    <li><Link to="/contas">Contas Públicas</Link></li>
                                    <li><Link to="/contas/prestacaocontas">Prestação de Contas</Link></li>
                                    <li><Link to="/contas/camara">Decretos do Legislativo</Link></li>
                                    <li><Link to="/contas/audiencias">Audiências Públicas</Link></li>
                                    <li><Link to="/contas/audiencias/metasfiscais">Atas das Audiências Públicas de Apresentação de Metas Fiscais</Link></li>
                                </ul>
                            </li>
                            <li><Link to="/diario">Diário Eletrônico Oficial</Link></li>
                            <li><Link to="/atos">Atos Normativos</Link></li>
                            <li><Link to="/partidospoliticos">Liberação de Verba</Link></li>
                            <li>
                                <h4>Obras</h4>
                                <ul>
                                    <li><Link to="/obras">Obras</Link></li>
                                    <li><Link to="/obras/todas">Todas as Obras</Link></li>
                                    <li><Link to="/obras/paralizadas">Obras Paralisadas</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Balanços</h4>
                                <ul>
                                    <li><Link to="/balanco">Balanços</Link></li>
                                    <li><Link to="/balanco/listar">Todos Balanços</Link></li>
                                    <li><Link to="/balanco/orcamentario">Balanços Orçamentários</Link></li>
                                    <li><Link to="/balanco/financeiro">Balanços Financeiros</Link></li>
                                    <li><Link to="/balanco/patrimonial">Balanços Patrimoniais</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>LRF</h4>
                                <ul>
                                    <li><Link to="/lrf">LRF</Link></li>
                                    <li><Link to="/lrf/listar">Todas LRF</Link></li>
                                    <li><Link to="/lrf/rreo">RREO</Link></li>
                                    <li><Link to="/lrf/rgf">RGF</Link></li>
                                    <li><Link to="/lrf/dcrgf">DCRGF</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Ouvidoria</h4>
                                <ul>
                                    <li><Link to="/ouvidoria">E-SIC</Link></li>
                                    <li><Link to="/ouvidoria/cadastrar">Cadastrar Requisição</Link></li>
                                    <li><Link to="/ouvidoria/estatisticas">Estatísticas do E-sic</Link></li>
                                    <li><Link to="/ouvidoria/listar">Busca Requisição</Link></li>
                                    <li><Link to="/ouvidoria/manuais">Manuais</Link></li>
                                    <li><Link to="/ouvidoria/comopedir">Como Pedir Informação</Link></li>
                                    <li><Link to="/ouvidoria/comoacompanhar">Como Acompanhar Pedido</Link></li>
                                    <li><Link to="/ouvidoria/recurso">Como entrar com Recurso</Link></li>
                                    <li><Link to="/ouvidoria/leis">Leis de Acesso à Informação</Link></li>
                                    <li><Link to="/ouvidoria/informacoes">Informações Gerais do E-SIC</Link></li>
                                    <li><Link to="/ouvidoria/publicas">Pedidos de informação</Link></li>
                                    <li><Link to="/ouvidoria/sigilo">Pedidos de informação com sigilo</Link></li>
                                    <li><Link to="/ouvidoria/desclassificadas">Pedidos de informação desclassificados</Link></li>
                                    <li><Link to="/pesquisa">Pesquisa de Satisfação</Link></li>
                                    <li><Link to="/pesquisa/resultados">Resultados da Pesquisa de Satisfação</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Saúde</h4>
                                <ul>
                                    <li><Link to="/saude">Secretaria de Saúde</Link></li>
                                    <li><Link to="/saude/profissionais">Profissionais de Saúde</Link></li>
                                    <li><Link to="/saude/atasaudiencia">Atas de Audiência de Saúde</Link></li>
                                    <li><Link to="/saude/atasconselho">Atas do Conselho de Saúde</Link></li>
                                    <li><Link to="/saude/parecer">Parecer do Conselho de Saúde</Link></li>
                                    <li><Link to="/saude/planoanual">Plano Anual de Saúde</Link></li>
                                    <li><Link to="/saude/planomunicipal">Plano Municipal de Saúde</Link></li>
                                    <li><Link to="/saude/relatorioanual">Relatório Anual de Saúde</Link></li>
                                    <li><Link to="/saude/remume">REMUME</Link></li>
                                    <li><Link to="/saude/remume/listar">Listagem REMUME</Link></li>
                                    <li><Link to="/saude/covid">COVID</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Educação</h4>
                                <ul>
                                    <li><Link to="/educacao">Secretaria de Educação</Link></li>
                                    <li><Link to="/educacao/atasconselho">Atas do Conselho de Educação</Link></li>
                                    <li><Link to="/educacao/parecer">Parecer do Conselho de Educação</Link></li>
                                    <li><Link to="/educacao/planomunicipal">Plano Municipal de Educação</Link></li>
                                    <li><Link to="/educacao/relatorioanual">Relatório Anual de Educação</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Licitações</h4>
                                <ul>
                                    <li><Link to="/licitacao">Licitações</Link></li>
                                    <li><Link to="/licitacao/aviso">Avisos de Editais</Link></li>
                                    <li><Link to="/licitacao/andamento">Licitações em Andamento</Link></li>
                                    <li><Link to="/licitacao/encerradas">Licitações Encerradas</Link></li>
                                    <li><Link to="/licitacao/covid">Licitações durante a pandemia de COVID-19</Link></li>
                                    <li><Link to="/licitacao/dispensa-covid">Dispensas durante a pandemia de COVID-19</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Contratos</h4>
                                <ul>
                                    <li><Link to="/contratos">Contratos</Link></li>
                                    <li><Link to="/contratos/listar">Todos contratos</Link></li>
                                    <li><Link to="/contratos/covid">Contratos firmados durante a pandemia de COVID-19</Link></li>
                                    <li><Link to="/contratos/fiscais">Fiscais de contratos</Link></li>
                                    <li><Link to="/contratos/contratados">Contratados</Link></li>
                                    <li><Link to="/contratos/licitantes">Licitantes</Link></li>
                                    <li><Link to="/contratos/chamamentos">Chamamentos Públicos da Secretaria de Saúde</Link></li>
                                </ul>
                            </li>
                            <li>
                                <h4>Legislação</h4>
                                <ul>
                                    <li><Link to="/leis">Todas Leis</Link></li>
                                    <li><Link to="/leis/orcamento">Leis Orçamentárias</Link></li>
                                    <li><Link to="/leis/decretos">Decretos Municipais</Link></li>
                                    <li><Link to="/leis/municipais">Leis Municipais</Link></li>
                                    <li><Link to="/leis/transparencia">Leis de Transparência</Link></li>
                                    <li><Link to="/leis/loa">Lei Orçamentária Anual</Link></li>
                                    <li><Link to="/leis/ldo">Lei de Diretrizes Orçamentárias</Link></li>
                                    <li><Link to="/leis/ppa">Plano Plurialnual</Link></li>
                                    <li><Link to="/leis/covid">Decretos durante a pandemia de COVID-19</Link></li>
                                </ul>
                            </li>
                        </ul>
                    </nav>

                </Fragment>
            </Container >
            <Footer />
        </Fragment >
    );
}

export default MapaScreen;